export default "__VITE_ASSET__CTfRdC3j__"